// Customer-facing pricing for a driver's bid.
//
// The displayed price ALWAYS includes the €10 JustDeliver.ie booking fee:
//   total     = driver bid + booking fee
//   payNow    = booking fee + 10% booking charge (0% on bids under €100)
//   payDriver = driver bid − the 10% booking charge
// The 10% is always calculated on the ORIGINAL driver bid, never on the total.
export const customerOfferPricing = (offer = {}) => {
  const bid = Number(offer.price || 0);
  const bookingFee = Number(offer.platform_fee ?? 10);
  const charge = Number(offer.driver_access_fee ?? (bid >= 100 ? +(bid * 0.1).toFixed(2) : 0));
  const payNow = Number(offer.direct_fees_only_amount ?? +(bookingFee + charge).toFixed(2));
  const payDriver = Number(offer.direct_balance_due ?? +(bid - charge).toFixed(2));
  return {
    bid,
    bookingFee,
    payNow,
    payDriver,
    total: +(payNow + payDriver).toFixed(2),
  };
};

// "€10" when whole, "€10.50" otherwise — used in the booking-fee note.
export const feeLabel = (amount) => {
  const v = Number(amount || 0);
  return v % 1 === 0 ? `€${v}` : `€${v.toFixed(2)}`;
};

export const eur = (amount) => `€${(Number(amount) || 0).toFixed(2)}`;
